import React from 'react';
import { connect } from 'react-redux';
import { IconButton, Table, TableBody, TableCell, TableHead, TableRow } from '@mui/material';
import { DoneOutlined, ErrorOutlined, Visibility, Cached } from '@mui/icons-material';
import { dateTime } from '../../utils/parsing';
import BuildingsLoader from '../loaders/BuildingsLoader';
import { fetchNextExecutions } from '../../redux/actions/analytics-actions';
import { ExecutionsLoader, SchedulesLoader } from '../loaders/analytics';

const renderTiming = (e) => {
  if (e.finished) {
    // TODO: better time formatting
    return (
      <>
        {e.succeeded ? <DoneOutlined color="secondary" /> : <ErrorOutlined color="error" />}
        in {(new Date(e.finished) - new Date(e.started)) / 1000}s
      </>
    );
  }
  if (e.started) {
    return `Running for ${(new Date() - new Date(e.started)) / 1000}s`;
  }
  return 'In queue...';
};

const ExecutionsTable = ({
  executions,
  buildingsById,
  schedulesById,
  selected,
  onSelect,
  hasMoreExecutions,
  fetchNextPage,
}) => (
  <div className="qa-executions">
    <ExecutionsLoader />
    <SchedulesLoader />
    <BuildingsLoader />
    <Table>
      <TableHead>
        <TableRow>
          <TableCell>Id</TableCell>
          <TableCell>Queued</TableCell>
          <TableCell>Duration</TableCell>
          <TableCell>Schedule</TableCell>
          <TableCell>Data Begin</TableCell>
          <TableCell>Data End</TableCell>
          <TableCell>Buildings</TableCell>
        </TableRow>
      </TableHead>
      <TableBody>
        {executions.map((e) => (
          <TableRow key={e.id} selected={e.id === selected}>
            <TableCell>
              {e.id !== selected ? (
                <IconButton onClick={() => onSelect(e.id)} size="large">
                  <Visibility />
                </IconButton>
              ) : null}
              {e.id}
            </TableCell>
            <TableCell>{dateTime(e.queued)}</TableCell>
            <TableCell>{renderTiming(e)}</TableCell>
            <TableCell>{schedulesById[e.schedule_id]?.name}</TableCell>
            <TableCell>{dateTime(e.params?.begin)}</TableCell>
            <TableCell>{dateTime(e.params?.end)}</TableCell>
            <TableCell>
              {e.buildings.map((bid) => buildingsById[bid]?.name || bid).join(', ')}
            </TableCell>
          </TableRow>
        ))}
        {hasMoreExecutions ? (
          <TableRow>
            <TableCell colSpan={7}>
              <IconButton onClick={fetchNextPage} size="large">
                <Cached />
                Load more...
              </IconButton>
            </TableCell>
          </TableRow>
        ) : null}
      </TableBody>
    </Table>
  </div>
);

export default connect(
  ({
    analytics: {
      executions: { allIds, byId, nextPage },
      schedules: { byId: schedulesById },
    },
    entities: {
      buildings: { byId: buildingsById },
    },
  }) => ({
    executions: allIds.map((id) => byId[id]),
    buildingsById,
    schedulesById,
    hasMoreExecutions: !!nextPage,
  }),
  (dispatch) => ({
    fetchNextPage: () => dispatch(fetchNextExecutions),
  })
)(ExecutionsTable);
